<template>
	<v-btn :height="height" :width="width" :color="color" class="btn-back" @click="goBack">
		<SIcon v-if="icon" :name="icon" />
		<v-icon v-else style="color: #6b7786">mdi-arrow-left</v-icon>
	</v-btn>
</template>
<script>
export default {
	name: 'BackButton',
	components: {},
	props: {
		height: { type: String, default: '40' },
		width: { type: String, default: '40' },
		color: { type: String, default: '#ECEEEF' },
		goBackName: { type: String },
		params: { type: Object },
		icon: { type: String },
	},
	methods: {
		goBack() {
			const payload = {
				name: this.goBackName,
			};
			if (this.params) {
				payload.params = this.params;
			}
			this.$router.push(payload);
		},
	},
	computed: {},
};
</script>
